import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoggerService } from './services/logger/logger.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public header: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public selectedstatus: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor( private loggerService:LoggerService) { }
  getNotificationPreference() {
    return localStorage["notification_pref"];
  }
  saveNotificationPreference(value: any) {
    localStorage["notification_pref"] = value;
  }
}
